var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hid)?_c('div',{staticClass:"testI18n"},[_c('span',{on:{"click":function($event){return _vm.test('zh-cn')}}},[_vm._v("中")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.test('en-us')}}},[_vm._v("英")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d14335a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/component/testCheckI18n.vue
// module id = null
// module chunks = 